export function resolveCurrentUserKey(currentUser: unknown): string | null {
  if (!currentUser || typeof currentUser !== 'object') {
    return null;
  }

  const user = currentUser as { id?: unknown; tenantId?: unknown };
  const userId = typeof user.id === 'string' ? user.id : '';
  const tenantId = typeof user.tenantId === 'string' ? user.tenantId : '';

  if (!userId) {
    return null;
  }

  return `${userId}:${tenantId}`;
}
